import {
  DiscordIcon,
  TwitterIcon,
} from "@/src/icons";
export const socialLinks = [
  {
    icon: <DiscordIcon />,
    href: "https://discord.gg/hwgHbMMvev",
  },
  {
    icon: <TwitterIcon />,
    href: "https://twitter.com/TheCanaryReborn",
  },
];
